<template class="custom-container-bg">
  <div>
    <dashboard v-if="showChart"></dashboard>
    <data-list :payload="modelObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination" class="select_checkbox_column_width_0" ref="sortableTable">
      <template slot="filterForm">
        <v-layout row class="pa-3">
          <v-flex lg1 sm2>
            <v-btn  color="primary" class="ml-2" :to="`/${this.MODULE_URL}/actions?orderId=${$route.params.order_id || 0}`" dark>{{ $t('message.common.new') }}</v-btn>
          </v-flex>
          <v-flex lg3 sm4>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="grey" dark v-bind="attrs" v-on="on" class="mx-2 px-2" :loading="downloadLoading">
                  <v-icon class="mr-1">mdi-file-export-outline</v-icon> {{$t('message.common.export')}} </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in listDownloadTypes" :key="index" @click="generateReport(item.value)">
                    <v-list-item-action>
                      <v-icon>{{ item.value === 'pdf' ? 'mdi-file-pdf-box' : 'mdi-microsoft-excel' }}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content class="py-0">
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-flex>
          <v-flex lg2 sm3 class="px-1">
            <v-autocomplete autocomplete="off" outlined dense hide-details :items="listOfDevationStatus" v-model="filterByStatusId" :label="$t('message.tickets.status')" item-text="name" item-value="id" @change="getListHandler" clearable></v-autocomplete>
          </v-flex>
          <v-flex lg2 sm3>
            <v-text-field persistent-hint :hint="$t('message.common.searchTriggerHint')" clearable append-icon="search" @keyup.enter="getListHandler" @click:append="getListHandler" outlined dense single-line v-model="search" :label="$t('message.common.search')" class="search-hint-padding" id="searchbtn"></v-text-field>
          </v-flex>
          <v-flex lg2 sm3 class="px-1 text-right">
            <v-chip class="ma-1" label>
              <span class="subtitle-1">{{ $t('message.deviations.openedDeviation') }}: {{ openedDeviation }}</span>
            </v-chip>
            <v-progress-circular color="primary" v-if="openDeviationLoading" indeterminate></v-progress-circular>
          </v-flex>
          <v-flex lg2 sm3 class="px-1 text-right">
            <v-btn color="primary" @click="showChart = !showChart">
              <v-icon>mdi-chart-box-outline</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </data-list>
  </div>
</template>
<script>
import DataList from '../../components/DataList.vue'
import { mapState } from 'vuex'
import deviationReport from '@/mixins/Deviation/index'
// import Sortable from 'sortablejs'
import axios from 'axios'

export default {
  data () {
    return {
      MODULE_URL: 'deviations',
      modelObj: {
        isHeader: true,
        isHideAdd: false,
        selection: [],
        showSelect: true,
        isDeviation: true,
        export: this.generateReport,
        addNewRoute: () => this.$router.push(`/${this.MODULE_URL}/actions?orderId=${this.$route.params.order_id || 0}`),
        list: [],
        loading: true,
        page: 1,
        editProp: 'title',
        editURL: (item) => `/${this.MODULE_URL}/actions/${item.id}`,
        editProp4: 'ordernumber',
        editURL4: (item) => `/orders/edit/${item.orderid}/view`,
        statusColor: 'deviationstatus_name',
        applyColor: 'deviationstatus_color',
        hasFilters: true
      },
      downloadLoading: false,
      total: 0,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.DEVIATION_INDEX) ? this.$store.state.DEVIATION_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      search: '',
      filterByStatusId: 0,
      openedDeviation: 0,
      openDeviationLoading: false,
      showChart: false
    }
  },
  components: {
    DataList,
    dashboard: () => import('./Dashboard.vue')
  },
  mixins: [deviationReport],
  computed: {
    ...mapState(['DEVIATION_INDEX', 'listOfDevationStatus']),
    headers () {
      return [{
        text: this.$t('message.product.number'),
        value: 'number',
        width: '4%'
      }, {
        text: `${this.$t('message.deviations.title')}`,
        value: 'title',
        width: '35%'
      }, {
        text: `${this.$t('message.layout.order')}`,
        value: 'ordernumber',
        width: '15%'
      }, {
        text: this.$t('message.deviations.estimatedInternalCost'),
        value: 'estimated_internal_cost',
        width: '10%'
      }, {
        text: this.$t('message.tickets.status'),
        value: 'deviationstatus_name',
        width: '15%'
      }, {
        text: this.$t('message.deviations.created_on'),
        value: 'created_on',
        width: '7%'
      }, {
        text: this.$t('message.deviations.deadline'),
        value: 'deadline',
        width: '7%'
      }, {
        text: this.$t('message.common.completed'),
        value: 'completeddate',
        width: '7%'
      }]
    },
    listDownloadTypes () {
      return [{
        text: 'PDF',
        value: 'pdf'
      }, {
        text: 'Excel',
        value: 'excel'
      }]
    }
  },
  created () {
    this.$store.dispatch('getDeviationStatus')
  },
  watch: {
    search (val) {
      if (!val) {
        this.pagination.search = val
        this.getListHandler()
      }
    },
    pagination (val) {
      let model = { type: 'DEVIATION_INDEX', data: val }
      this.$store.commit('rememberOrder', model)
      this.getListHandler()
    }
  },
  mounted () {
    this.getOpenedDeviation()
    if (!this.$formatter.isEmptyObject(this.$store.state.F_DEVIATION)) {
      let deviationFilters = this.$formatter.cloneVariable(this.$store.state.F_DEVIATION)
      let { status, search } = deviationFilters.filter
      this.filterByStatusId = status || 0
      this.search = search || ''
    }
    /* eslint-disable no-new */
    // new Sortable(
    //   this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
    //   {
    //     draggable: '.sortableRow table tbody tr',
    //     onEnd: this.dragReorder
    //   }
    // )
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE_URL) {
        let payload = { ids: data.ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.modelObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    dragReorder ({ oldIndex, newIndex }) {
      const movedItem = this.modelObj.list.splice(oldIndex, 1)[0]
      this.modelObj.list.splice(newIndex, 0, movedItem)
      this.getDeviationSortOrderIds()
    },
    getDeviationSortOrderIds () {
      let ids = []
      for (let i = 0; i < this.modelObj.list.length; i++) {
        ids[i] = this.modelObj.list[i].id
      }
      ids = { 'ids': this.$formatter.cloneVariable(ids) }
      this.$_executeApi('post', `${this.MODULE_URL}/set_order`, ids)
        .then((response) => {
        })
    },
    getListHandler () {
      this.modelObj.loading = true
      this.modelObj.module = this.MODULE_URL
      let { page, sortBy, sortDesc, itemsPerPage } = this.$formatter.cloneVariable(this.pagination)
      let sortByValue = ''
      if (sortBy && sortBy[0] && sortBy[0] === 'type_name') sortByValue = 'type'
      else if (sortBy && sortBy[0]) sortByValue = sortBy[0]
      let model = {
        descending: sortDesc && sortDesc[0],
        page,
        orderid: this.$route.params.order_id || 0,
        sortby: sortByValue,
        search: this.search,
        rowsperpage: itemsPerPage,
        status: this.filterByStatusId || 0
      }
      this.$_executeApi('post', `${this.MODULE_URL}/paginate_filter`, model)
        .then((response) => {
          let { items, total } = response.data
          this.modelObj.loading = false
          let transformData = { date: { list: ['created_on', 'deadline', 'closedon', 'completeddate'], from: 'DD.MM.YYYYTHH:mm:ss', to: 'DD.MM.YYYY' } }
          let model = this.$_formatListModel(items, transformData)
          this.modelObj.list = model
          this.total = total
          if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
            this.pagination.page = 1
            this.modelObj.page = 1
          }
          let data = { type: 'F_DEVIATION', data: { filter: { status: this.filterByStatusId || 0, search: this.search } } }
          this.$store.commit('rememberFilter', data)
        })
    },
    async generateReport (type, ids) {
      this.downloadLoading = true
      var deviationIds = ids || []
      var content = await this.genereateReportContent(deviationIds)
      const model = {
        filetype: type,
        ids: deviationIds,
        pdfcontent: { content }
      }
      this.$_executeApi('post', 'deviations/generate_report', model).then(response => {
        this.downloadLoading = false
        const fileName = response.data
        window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
      }).finally(() => {
        this.downloadLoading = false
      })
    },
    getOpenedDeviation () {
      this.openDeviationLoading = true
      this.$_executeApi('get', 'deviations/get_opened_deviations')
        .then((response) => {
          this.openedDeviation = response.data || 0
        })
        .finally(() => {
          this.openDeviationLoading = false
        })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
